import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/permission' // permission control

import "element-plus/theme-chalk/el-message.css"
import 'element-plus/theme-chalk/display.css'

import "@/styles/index.scss"
import "@/styles/element-ui.scss"

createApp(App).use(store).use(router).mount('#app')
